import { authConfig } from "../apiConfig";


export const get_workforce_with_out_pagination = async () => {
    try {
        const response = await authConfig.post(`getUserlist`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_workforce_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getUserlist`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_workforce_by_id = async (data) => {
    try {
        const response = await authConfig.post(`userViewById`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const workforce_creation = async (data) => {
    try {
        const response = await authConfig.post(`addUsers`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const workforce_update = async (data) => {
    try {
        const response = await authConfig.post(`updateUser`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};